const groupPrefix = createApiRoute(ApiModule.DIETARY, ApiDataModel.ALLERGENS)

export const apiAllergens = {
	fetchDietAllergens: async (search: string | undefined, page: number = 1, perPage: number = 25) => {
		const { data, meta } = await apiCommon<IDietAllergen[]>(`${groupPrefix}`, {
			method: 'GET',
			...createQuery({ page, perPage }, { name: search }),
		})
		return { data: data.map(d => DietAllergen(d)), meta }
	},

	addNewAllergen: async (body: Partial<IDietAllergen>) => {
		const { data } = await apiCommon<IDietAllergen>(`${groupPrefix}`, {
			method: 'POST',
			body,
		})
		return DietAllergen(data)
	},

	editAllergen: async (body: Partial<IDietAllergen>) => {
		const { data } = await apiCommon<IDietAllergen>(`${groupPrefix}/${body.id}`, {
			method: 'PUT',
			body,
		})

		return DietAllergen(data)
	},

	deleteAllergen: async (id: number) => {
		await apiCommon<string>(`${groupPrefix}/${id}`, {
			method: 'DELETE',
		})
	},
}
